export const authTokenName = "BUHRAuthToken"